export default "__VITE_ASSET__cgMgzX_N__"